<script lang="ts">
    import {Utils} from "./util";
    import {translations} from "./config";

    export let content: string;

    let isOpen = false;
    let panel: HTMLDivElement;

    function onClick() {
		isOpen = !isOpen;
    }

</script>
<div bind:this={panel} class="panel" style="max-height: {isOpen ? panel.scrollHeight + 'px' : ''}">
    {@html content}
</div>
<button class="accordion" class:active={isOpen} on:click={onClick}>
    <img src={isOpen ? './map/img/minus_24px.png' : './map/img/plus_24px.png'}
         class="icon" alt="{isOpen ? 'close' : 'open'}" style="margin-right: 0.5rem;">
    {Utils.chooseTranslation(isOpen ? translations.accordionLess : translations.accordionMore)}
</button>
<div class="table-cell"></div>
<div class="table-cell"></div>
